module.exports = __webpack_public_path__ + "static/media/Kuldeep_Singh_Resume.00ec9a40.pdf";